export function normalizeHex(value, fallback) {
    if (typeof value !== "string") return fallback;
    const trimmed = value.trim();
    if (!trimmed) return fallback;
    const withHash = trimmed.startsWith("#") ? trimmed : `#${trimmed}`;
    const isValid = /^#[0-9a-fA-F]{3}([0-9a-fA-F]{3})?$/.test(withHash);
    return isValid ? withHash : fallback;
}
